<table class="match-table">
  <thead>
    <tr>
      <th style="min-width: 140px; max-width: 140px; text-align: left">Task Info</th>
      <th style="width: 44%; text-align: left" colspan="2" class="pick-up-color">
        <i class="vme-material-icons">&#xe805;</i> Pick-up
      </th>
      <th style="width: 44%; text-align: left" colspan="2" class="drop-off-color">
        <i class="vme-material-icons">&#xe804;</i> Drop-off
      </th>
      <th style="width: 4%; text-align: right">Fee</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let task of orderInfo.tasks">
      <td>
        <div class="task-type">
          {{ task.actualTaskTypeName ? task.actualTaskTypeName : task.taskTypeName }}
        </div>
        <div class="vrm">{{ task.vehicle.registrationNumber }}</div>
        <div class="vehicle-data">
          {{ task.vehicle.color }} {{ task.vehicle.make }} {{ task.vehicle.model }}
        </div>
      </td>
      <td
        style="min-width: 160px; max-width: 160px; text-align: left; margin-left: 10px"
        class="pick-up-color"
      >
        <div>
          <i class="fa fa-clock-o" pTooltip="Earliest" tooltipPosition="left"></i>
          {{ task.pickupEarliestDateTime | datex : "ddd DD MMM 'YY HH:mm" }}
          <br />
          <i class="fa fa-clock-o" pTooltip="Latest" tooltipPosition="left"></i>
          {{ task.pickupLatestDateTime | datex : "ddd DD MMM 'YY HH:mm" }}
        </div>
      </td>
      <td style="width: 22%; text-align: left" class="pick-up-color">
        <div>{{ task.pickupLocation.city }}</div>
        <div>{{ task.pickupLocation.postcode | postcode }}</div>
      </td>
      <td style="min-width: 160px; max-width: 160px; text-align: left" class="drop-off-color">
        <i class="fa fa-clock-o" pTooltip="Earliest" tooltipPosition="left"></i>
        {{ task.dropoffEarliestDateTime | datex : "ddd DD MMM 'YY HH:mm" }}
        <br />
        <i class="fa fa-clock-o" pTooltip="Latest" tooltipPosition="left"></i>
        {{ task.dropoffLatestDateTime | datex : "ddd DD MMM 'YY HH:mm" }}
      </td>
      <td style="width: 22%; text-align: left" class="drop-off-color">
        <div>{{ task.dropoffLocation.city }}</div>
        <div>{{ task.dropoffLocation.postcode | postcode }}</div>
      </td>
      <td style="text-align: right">
        £{{ isECJob ? orderInfo.existingCapacityPrice : orderInfo.supplierPrice }}
      </td>
    </tr>
    <tr>
      <td colspan="5">&nbsp;</td>
      <td style="text-align: right">
        £{{ isECJob ? orderInfo.existingCapacityPrice : orderInfo.supplierPrice }}
      </td>
    </tr>
  </tbody>
</table>
